var _rect, _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _rect2, _rect3, _rect4, _path7, _path8, _circle3, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 900,
    viewBox: "0 0 1200 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 900,
    rx: 36,
    fill: "#F8FCFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138 618C138 530.186 209.186 459 297 459H903C990.814 459 1062 530.186 1062 618V654C1062 741.814 990.814 813 903 813H297C209.186 813 138 741.814 138 654V618Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M224 274C224 189.123 292.123 121 377 121H823C907.877 121 976 189.123 976 274V356C976 440.877 907.877 509 823 509H377C292.123 509 224 440.877 224 356V274Z",
    fill: "#EAF4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M324 334C324 240.111 400.111 164 494 164H706C799.889 164 876 240.111 876 334C876 427.889 799.889 504 706 504H494C400.111 504 324 427.889 324 334Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 334,
    r: 54,
    fill: "#0F766E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 334,
    r: 22,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M524 296H742",
    stroke: "#132238",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M524 344H694",
    stroke: "#D8E0EA",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M524 386H652",
    stroke: "#D8E0EA",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 556,
    width: 232,
    height: 150,
    rx: 24,
    fill: "#EEF7FB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 484,
    y: 556,
    width: 232,
    height: 150,
    rx: 24,
    fill: "#ECF9F4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 746,
    y: 556,
    width: 232,
    height: 150,
    rx: 24,
    fill: "#FFF4D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M290 616H388",
    stroke: "#132238",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M278 646H400",
    stroke: "#D8E0EA",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 602,
    r: 22,
    stroke: "#0F766E",
    strokeWidth: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M560 598H640",
    stroke: "#0F766E",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M548 640H652",
    stroke: "#132238",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M800 598H922",
    stroke: "#F59E0B",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M800 640H884",
    stroke: "#132238",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M854 578V660",
    stroke: "#F59E0B",
    strokeWidth: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportMap);
export default __webpack_public_path__ + "static/media/support-map.625c1693eabcd96a6fe399aeab2b107f.svg";
export { ForwardRef as ReactComponent };